import { OPPORTUNITY_PATH } from "@/modules/crm/pages/opportunity";
import { generatePath, Navigate } from "react-router-dom";
import { ToPageNotFound } from "@/shared/redirects/to-page-not-found";

/**
 * Ссылка из напоминания по задаче сделки. У маршрута сделки `id` необязателен —
 * без него `generatePath` дал бы пустую страницу, поэтому ссылку без `id` считаем битой.
 */
export function OpenOpportunity() {
  const url = new URL(window.location.href);
  const id = url.searchParams.get("id");

  if (!id) {
    return <ToPageNotFound />;
  }

  return <Navigate to={generatePath(OPPORTUNITY_PATH, { id })} />;
}
